import { render, staticRenderFns } from "./RecoveryForgotPassword.vue?vue&type=template&id=01258508&"
import script from "./RecoveryForgotPassword.vue?vue&type=script&lang=js&"
export * from "./RecoveryForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports